import React, { useContext } from 'react';
import AppContext from '../context/Context';
import RewardsRoutes from '../routes/RewardsRoutes';

const RewardsLayout = () => {
    const { isFluid } = useContext(AppContext);

    return  <div className={isFluid ? 'container-fluid' : 'container'}>
                <RewardsRoutes />
            </div>
}

export default RewardsLayout;
